export { default } from "./TextareaAutosize.mjs";